import { dateToYMD, localDateToYMD } from '@shared/utils/date';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/items/src/periodicReviewDates.ts
export const isPeriodicReviewDue = (value?: string | null): boolean => {
  const ymd = dateToYMD(value);
  return Boolean(ymd) && ymd <= localDateToYMD();
};
